package fr.frux.core.network.api

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.network.ApiPaths
import fr.frux.shared.dto.CreateFeedbackRequest
import io.ktor.client.HttpClient
import io.ktor.client.request.post
import io.ktor.client.request.setBody

/**
 * Retour utilisateur in-app (#437, ADR 0028). 201 sans corps en nominal. Le serveur rejette en 400
 * `VALIDATION` (texte hors 10 à 2 000 caractères, contexte vide), 401 sans session, 429
 * `FEEDBACK_LIMIT` (5 retours sur 24 heures, traduit en quota épuisé par `toAppError`). POST
 * jamais rejoué par le client (`HttpRequestRetry` limité à GET/HEAD) : pas de doublon.
 */
interface FeedbackApi {
    suspend fun sendFeedback(request: CreateFeedbackRequest)
}

@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class FeedbackApiImpl(
    private val httpClient: HttpClient,
) : FeedbackApi {
    override suspend fun sendFeedback(request: CreateFeedbackRequest) {
        httpClient.post("${ApiPaths.V1}/feedback") {
            setBody(request)
        }
    }
}
